// Module
var code = `<ex-multi-occurrence-analyse ex-bloc="rae" multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;